import React, {createContext, useContext, useMemo} from 'react';

const noOp = (() => {
});

const EventCapture = createContext(noOp);

export const useEventCapture = () => {
  return useContext(EventCapture);
};

export function EventCaptureProvider({children, capture, capturePlayerLoadTime, captureSentryError, shouldPhoenixSkipFiringStandardVastPixel, captureAssetLoadingTime, recordCardExposureStart, recordCardExposureEnd, getTotalCardExposureTime, clearCardExposureTime}) {

  const captureFunctions = useMemo(() => ({
    capture, capturePlayerLoadTime, captureSentryError, shouldPhoenixSkipFiringStandardVastPixel, captureAssetLoadingTime, recordCardExposureStart, recordCardExposureEnd, getTotalCardExposureTime, clearCardExposureTime
  }), [capture, capturePlayerLoadTime, captureSentryError, shouldPhoenixSkipFiringStandardVastPixel, captureAssetLoadingTime, recordCardExposureStart, recordCardExposureEnd, getTotalCardExposureTime, clearCardExposureTime]);

  return <EventCapture.Provider value={captureFunctions}>
    {children}
  </EventCapture.Provider>
}
